module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg1-bee09f1c8ec7ada86e7f0e4c80faffff.jpg";